import type { Dtos, NaicsCodeId, Rate, SuretyQuoteStatus } from "@inrev/common";
import type { AdminSuretyBond } from "@portal/api/bond/admin/types";
import type { BondFormQueryState } from "@portal/api/bond-request/admin";
import type { AdminBondRequest } from "@portal/api/bond-request/admin/types";
import type { useQuoteFollowers } from "@portal/api/followers";

export type FollowersControl = ReturnType<typeof useQuoteFollowers>;

export type { BondFormQueryState };

export type BondRequestTabProps = {
	request: AdminBondRequest;
	bondFormQuery: BondFormQueryState;
	accountRate: Rate | undefined;
	accountDisplayName: string;
	accountNaicsCodes: NaicsCodeId[];
	followersControl: FollowersControl;
	bidBond: AdminSuretyBond | undefined;
	underwriting?: Dtos.Admin.Quote.Underwriting | null;
};

export const canChangeTerms = (
	request: AdminBondRequest,
): request is AdminBondRequest & {
	status: Extract<SuretyQuoteStatus, "approved" | "accepted">;
} => request.status === "approved" || request.status === "accepted";
